import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Dialog, Tooltip, IconButton, DialogTitle } from "@mui/material";
import { Close as CloseIcon, WrapText } from "@mui/icons-material";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import "../css/Dialog.css";

import invoiceApi from "../api/invoiceApi";

const InvoiceHistoryModal = React.memo(({ open, onClose, reiId }) => {
  const [histories, setHistories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchInvoiceHistory = async () => {
      if (!open) return;
      setLoading(true);
      try {
        const response = await invoiceApi.getInvoiceHistory(reiId);
        setHistories(response.data);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoiceHistory();
  }, [open, reiId]);

  const columns = [
    {
      field: "ReihCreateDate",
      headerName: "Ngày tạo",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: (params) => {
        return dayjs(params.value).format("DD/MM/YYYY HH:mm:ss");
      },
    },
    {
      field: "ReihTypeName",
      headerName: "Loại",
      headerAlign: "center",
      align: "center",
      width: 160,
    },
    {
      field: "ReihStatusName",
      headerName: "Trạng thái",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    {
      field: "ReihResponseData",
      headerName: "Nội dung",
      headerAlign: "center",
      flex: 1,
    },
  ];
  return (
    <Dialog open={open} fullWidth maxWidth="md" className="ui-dialog">
      <DialogTitle className="ui-dialog-titlebar">Lịch sử hoá đơn</DialogTitle>
      <Tooltip title="Đóng">
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: "absolute",
            right: 4,
            top: 4,
            color: "white",
          })}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
      <div className="ui-dialog-content">
        <DataGrid
          rows={histories}
          columns={columns}
          loading={loading}
          getRowId={(row) => row.ReihId}
          showCellVerticalBorder
          showColumnVerticalBorder
        ></DataGrid>
      </div>
    </Dialog>
  );
});

export default InvoiceHistoryModal;
